import React from "react";
import { CloudSun, Gauge, Waves, Wind } from "lucide-react";

const diagrams = [
  { icon: Wind, title: "Wind scale", alt: "Diagram showing calm, useful sailing wind, caution wind and unsafe strong wind bands", bars: [35, 58, 78], labels: ["Calm", "Sail", "Caution"] },
  { icon: Waves, title: "Sea state", alt: "Diagram showing low waves, moderate waves and rough seas for sailors", bars: [28, 52, 84], labels: ["Low", "Moderate", "Rough"] },
  { icon: Gauge, title: "Pressure trend", alt: "Diagram showing rising, stable and falling pressure signals", bars: [70, 54, 32], labels: ["Rising", "Stable", "Falling"] },
  { icon: CloudSun, title: "Sky signals", alt: "Diagram showing clear sky, building clouds and storm clouds", bars: [22, 50, 90], labels: ["Clear", "Build", "Storm"] },
];

export default function WeatherMiniDiagrams() {
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {diagrams.map(({ icon: Icon, title, alt, bars, labels }) => (
        <div key={title} role="img" aria-label={alt} className="rounded-3xl border border-border bg-background/70 p-4">
          <Icon className="h-5 w-5 text-primary" />
          <h4 className="mt-3 font-black">{title}</h4>
          <div className="mt-4 flex h-20 items-end gap-2">
            {bars.map((height, index) => (
              <div key={labels[index]} className="flex flex-1 flex-col items-center gap-2">
                <div className="w-full rounded-t-xl bg-gradient-to-t from-primary to-accent" style={{ height: `${height}%` }} />
                <span className="text-[10px] font-bold text-muted-foreground">{labels[index]}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}